import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-steeldart',
  templateUrl: './steeldart.component.html',
  standalone: true,
  imports: [
    RouterLink
  ],
  styleUrls: ['./steeldart.component.less']
})
export class SteeldartComponent {

}
